import {
  AddressValidationSchema,
  CURRENT_ADDRESS,
  EXISTING_ADDRESS,
  NO_ADDRESS,
  PersonAddressSchema,
} from "src/schemas/Address";
import {
  BASE_INITIAL_STUDENT_FORM,
  StudentAttendanceItemSchema,
  StudentAttendanceSchema,
  StudentSchema,
  StudentValidator,
} from "src/schemas/Student";
import { z } from "zod";

export const StudentProfileSchema = StudentSchema.extend({
  address: PersonAddressSchema.merge(
    z.object({
      kind: z.union([
        z.literal(CURRENT_ADDRESS),
        z.literal(EXISTING_ADDRESS),
        z.literal(NO_ADDRESS),
      ]),
    })
  ),
});

export type StudentProfileForm = z.infer<typeof StudentProfileSchema>;

export const StudentProfileValidator = StudentValidator.extend({
  address: AddressValidationSchema,
});

export type StudentProfileFormAttendanceItem = z.infer<
  typeof StudentAttendanceItemSchema
>;

export type StudentProfileFormAttendance = z.infer<
  typeof StudentAttendanceSchema
>;

export const INITIAL_STUDENT_PROFILE: StudentProfileForm = {
  ...BASE_INITIAL_STUDENT_FORM,
  address: {
    kind: NO_ADDRESS,
    street_address: "",
    street_address_line_2: "",
    city: "",
    state: "",
    zip_code: "",
  },
};
